import { Capacitor } from "@capacitor/core";

const KEY = "gbc.store-app";

/** Repère l'application installée depuis l'App Store (WebView Capacitor) ou Google Play (Trusted Web Activity). */
function detect() {
  if (typeof window === "undefined") return null;
  const ua = navigator.userAgent;
  if (/GBCCoachApp/.test(ua) || Capacitor.isNativePlatform()) return /iPhone|iPad|iPod|Macintosh/.test(ua) ? "ios" : "android";
  const params = new URLSearchParams(window.location.search);
  if (params.get("source") === "android" || document.referrer.startsWith("android-app://")) return "android";
  return null;
}

let store: "ios" | "android" | null = detect();
try {
  if (store) sessionStorage.setItem(KEY, store);
  else store = (sessionStorage.getItem(KEY) as typeof store) ?? null;
} catch {
  /* stockage indisponible */
}

/** Application des stores : les achats d'abonnement se font hors de l'application (règles Apple 3.1.1 et Google Play). */
export const storeApp = store;
export const isStoreApp = Boolean(store);
export const isIosApp = store === "ios";
